import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  NgbDateParserFormatter,
  NgbDatepickerModule,
} from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CheckBoxListComponent } from './checkbox-list/checkbox-list.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { DatepickerParserFormatter } from './datepicker/datepicker-parser-formatter';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { FileReaderComponent } from './file-reader/file-reader.component';
import { GetSecureImageSourcePipe } from './get-secure-img-source/get-secure-img-source.pipe';
import { NumericInputComponent } from './numeric-input/numeric-input.component';
import { RadioComponent } from './radio/radio.component';
import { SelectComponent } from './select/select.component';
import { SignaturePad } from './signature/signature-pad/signature-pad.component';
import { SignatureComponent } from './signature/signature.component';
import { WatermarkDirective } from './signature/watermark.directive';
import { SwitchComponent } from './switch/switch.component';
import { TextInputComponent } from './text-input/text-input.component';
import { TimepickerComponent } from './timepicker/timepicker.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    NgbDatepickerModule,
    ReactiveFormsModule,
  ],
  declarations: [
    CheckboxComponent,
    SelectComponent,
    DatepickerComponent,
    RadioComponent,
    NumericInputComponent,
    SwitchComponent,
    TextInputComponent,
    FileReaderComponent,
    TimepickerComponent,
    CheckBoxListComponent,
    SignatureComponent,
    SignaturePad,
    GetSecureImageSourcePipe,
    WatermarkDirective,
  ],
  exports: [
    CheckboxComponent,
    SelectComponent,
    DatepickerComponent,
    RadioComponent,
    NumericInputComponent,
    SwitchComponent,
    TextInputComponent,
    FileReaderComponent,
    TimepickerComponent,
    CheckBoxListComponent,
    SignatureComponent,
    GetSecureImageSourcePipe,
    WatermarkDirective,
  ],
  providers: [
    { provide: NgbDateParserFormatter, useClass: DatepickerParserFormatter },
  ],
})
export class UiKitCoreModule {}
